import * as navigation from './navigation';
import * as tags from './tags';

export const reducers = { ...tags.reducers, ...navigation.reducers };
export const actions = { tags: tags.actions, navigation: navigation.actions };
